import styled from "styled-components";

export const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

interface PopoverProps {
  top: number;
  left: number;
}

export const Popover = styled.div<PopoverProps>`
  position: fixed;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  transform: translateX(calc(-100% - 8px));
  z-index: 9999;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 14px;
  min-width: 300px;
  max-width: 360px;
  max-height: calc(100vh - 16px);
  overflow-y: auto;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  pointer-events: none;
`;
